<div
  class="conditions-menu flow-menu"
  #connectorMenuElement
  [hidden]="!selected"
>
  <div class="heading" (click)="$event.stopPropagation()">
    <div class="title">Conditions</div>
    <div class="heading-mode-toggle">
      <button
        type="button"
        mat-button
        class="mode-toggle-btn"
        [class.mode-toggle-btn--active]="conditionMode === 'structured'"
        (click)="requestConditionMode('structured', $event)"
      >
        Structured
      </button>
      <button
        type="button"
        mat-button
        class="mode-toggle-btn"
        [class.mode-toggle-btn--active]="conditionMode === 'ai'"
        (click)="requestConditionMode('ai', $event)"
      >
        AI prompt
      </button>
    </div>
  </div>
  <div class="content" (click)="$event.stopPropagation()">
    <div *ngIf="conditionMode === 'ai'" class="ai-prompt-section">
      <div class="container-row">
        <label class="ai-label">Describe when this path should be taken</label>
        <textarea
          class="ai-prompt-textarea"
          rows="6"
          [formControl]="aiPromptControl"
          placeholder="Natural language rules for continuing this branch…"
        ></textarea>
      </div>
      <div class="container-row ai-web-search-row">
        <mat-checkbox
          class="mat-lightGreen"
          color="primary"
          [formControl]="aiWebSearchControl"
        >
          Enable web search
        </mat-checkbox>
        <div class="ai-web-search-hint">
          Allow the model to look up current public facts (weather, local
          hours, recent events) when the context isn't enough to decide.
        </div>
      </div>
    </div>

    <div
      class="condition-box"
      *ngFor="let condition of conditions; let idx = index"
      [hidden]="conditionMode !== 'structured'"
    >
      <div class="condition">
        <div class="container-row">
          <div class="when">When</div>
        </div>

        <!-- CONDITIONAL -->
        <div class="container-row">
          <lhpe-select
            controlName="conditional"
            placeholder="Conditional"
            [formGroup]="condition.formGroup!"
            [options]="filters"
            displayValue="label"
            [optionIsSelf]="true"
            [required]="true"
            groupBy="group"
            (change)="resetCondition(condition)"
          >
          </lhpe-select>
        </div>

        <!-- OPERATOR -->
        <div
          *ngIf="condition.formGroup.controls.conditional.value"
          class="container-row"
        >
          <lhpe-select
            controlName="operator"
            placeholder="Operator"
            [formGroup]="condition.formGroup!"
            [options]="
              condition.formGroup.controls.conditional.value.comparisons
            "
            displayValue="name"
            optionValue="operator"
            [required]="true"
          >
          </lhpe-select>
        </div>

        <!-- VALUE -->

        <!-- LOCATION PERMISSION -->
        <div
          *ngIf="
            condition.formGroup.controls.conditional.value?.type === 'locationPermission'
          "
          class="container-row"
        >
          <lhpe-select
            controlName="value"
            placeholder="Value"
            [formGroup]="condition.formGroup!"
            [options]="locationPermissionOptions"
            displayValue="label"
            optionValue="value"
            [required]="true"
            [multiple]="true"
          >
          </lhpe-select>
        </div>

        <!-- EMAIL STATUS -->
        <div
          *ngIf="
            condition.formGroup.controls.conditional.value?.type === 'emailStatus'
          "
          class="container-row"
        >
          <lhpe-select
            controlName="value"
            placeholder="Value"
            [formGroup]="condition.formGroup!"
            [options]="emailStatusOptions"
            displayValue="label"
            optionValue="value"
            [required]="true"
            [multiple]="true"
          >
          </lhpe-select>
        </div>

        <!-- BOOLEAN, IS NULL, SIGNAL READ -->
        <div
          *ngIf="
            condition.formGroup.controls.conditional.value?.type === 'boolean' ||
            condition.formGroup.controls.conditional.value?.type === 'isNull' ||
            condition.formGroup.controls.conditional.value?.type === 'signalRead'
          "
          class="container-row"
        >
          <lhpe-select
            controlName="value"
            placeholder="Value"
            [formGroup]="condition.formGroup!"
            [options]="booleanOptions"
            displayValue="name"
            optionValue="code"
            [required]="true"
          >
          </lhpe-select>
        </div>

        <!-- TIME ON STATION, LAST VISIT, TIME AFTER SENT -->
        <div
          *ngIf="
            condition.formGroup.controls.conditional.value?.type === 'timeOnStation' ||
            condition.formGroup.controls.conditional.value?.type === 'lastVisit' ||
            condition.formGroup.controls.conditional.value?.type === 'timeAfterSent'
          "
          class="container-row tos-row"
        >
          <lhpe-input
            class="input"
            controlName="tosDays"
            placeholder="Day(s)"
            [formGroup]="condition.formGroup!"
            [required]="true"
            type="number"
          >
          </lhpe-input>
          <lhpe-input
            class="input"
            controlName="tosHours"
            placeholder="Hour(s)"
            [formGroup]="condition.formGroup!"
            [required]="true"
            type="number"
          >
          </lhpe-input>
          <lhpe-input
            class="input"
            controlName="tosMinutes"
            placeholder="Minute(s)"
            [formGroup]="condition.formGroup!"
            [required]="true"
            type="number"
          >
          </lhpe-input>
        </div>

        <!-- DAY OF WEEK -->
        <div
          *ngIf="
            condition.formGroup.controls.conditional.value?.type === 'dayOfWeek'
          "
          class="container-row"
        >
          <lhpe-select
            controlName="value"
            placeholder="Day(s)"
            [formGroup]="condition.formGroup!"
            [options]="dayOfWeekOptions"
            [optionIsSelf]="true"
            [required]="true"
            [multiple]="true"
          >
          </lhpe-select>
        </div>

        <!-- DATE -->
        <div
          *ngIf="
            condition.formGroup.controls.conditional.value?.type === 'date'
          "
          class="container-row date-row"
        >
          <button mat-button class="icon-btn" (click)="datePicker.openPicker()">
            <svg-icon
              src="assets/svg/calendar.svg"
              [svgStyle]="{
                'width.px': '26.5',
                'height.px': '26.5'
              }"
              svgClass="grey"
            >
            </svg-icon>
          </button>
          <lhpe-datepicker
            #datePicker
            [hideToggle]="true"
            placeholder="mm/dd/yyyy"
            [formGroup]="condition.formGroup!"
            controlName="value"
          >
          </lhpe-datepicker>
        </div>

        <!-- INTEGER, FLOAT -->
        <div
          *ngIf="
            condition.formGroup.controls.conditional.value?.type === 'integer' ||
            condition.formGroup.controls.conditional.value?.type === 'float'
          "
          class="container-row"
        >
          <lhpe-input
            class="input"
            controlName="value"
            placeholder="Number"
            [formGroup]="condition.formGroup!"
            [required]="true"
            type="number"
          >
          </lhpe-input>
        </div>

        <!-- STRING, EMAIL -->
        <div
          *ngIf="
            condition.formGroup.controls.conditional.value?.type === 'string' ||
            condition.formGroup.controls.conditional.value?.type === 'email'
          "
          class="container-row"
        >
          <lhpe-input
            class="input"
            controlName="value"
            placeholder="Value"
            [formGroup]="condition.formGroup!"
            [required]="true"
          >
          </lhpe-input>
        </div>

        <!-- STRING[], INTEGER[] -->
        <div
          *ngIf="
            condition.formGroup.controls.conditional.value?.type === 'string[]' ||
            condition.formGroup.controls.conditional.value?.type === 'integer[]'
          "
          class="container-row"
        >
          <lhpe-input
            class="input"
            controlName="value"
            placeholder="Value"
            [formGroup]="condition.formGroup!"
            [required]="true"
          >
          </lhpe-input>
          Separate values with ,
        </div>

        <!-- SELECT -->
        <div
          *ngIf="
            condition.formGroup.controls.conditional.value?.type === 'select' &&
            condition.formGroup.controls.conditional.value?.opts
          "
          class="container-row"
        >
          <lhpe-select
            controlName="value"
            placeholder="Select"
            [formGroup]="condition.formGroup!"
            [options]="condition.formGroup.controls.conditional.value?.opts"
            [optionIsSelf]="false"
            displayValue="label"
            [required]="true"
          >
          </lhpe-select>
        </div>

        <!-- MULTI-SELECT -->
        <div
          *ngIf="
            condition.formGroup.controls.conditional.value?.type === 'multi-select' &&
            condition.formGroup.controls.conditional.value?.opts
          "
          class="container-row"
        >
          <lhpe-select
            controlName="value"
            placeholder="Value"
            [formGroup]="condition.formGroup!"
            [options]="condition.formGroup.controls.conditional.value?.opts"
            displayValue="label"
            optionValue="value"
            [required]="true"
            [multiple]="true"
          >
          </lhpe-select>
        </div>

        <ng-container
          *ngIf="
            condition.formGroup.controls.conditional.value?.type === 'timeOfDay'
          "
        >
          <div
            *ngIf="
              condition.formGroup.controls.operator.value === 'after' ||
              condition.formGroup.controls.operator.value === 'before'
            "
            class="container-row time-of-day"
          >
            <div class="row">
              <lhpe-select
                class="hour"
                controlName="timeOfDayHour"
                placeholder="hh"
                [formGroup]="condition.formGroup!"
                [required]="true"
                [options]="hourOptions"
                [optionIsSelf]="true"
              >
              </lhpe-select>

              <lhpe-select
                class="minute"
                controlName="timeOfDayMinutes"
                placeholder="mm"
                [formGroup]="condition.formGroup!"
                [required]="true"
                [options]="minuteOptions"
                [optionIsSelf]="true"
              >
              </lhpe-select>

              <lhpe-select
                class="pm"
                controlName="timeOfDayPM"
                [formGroup]="condition.formGroup!"
                [required]="true"
                [options]="pmOptions"
              >
              </lhpe-select>
            </div>
          </div>

          <div
            *ngIf="condition.formGroup.controls.operator.value === 'between'"
            class="container-row time-of-day"
          >
            <div class="row">
              <lhpe-select
                class="hour"
                controlName="startTimeOfDayHour"
                placeholder="hh"
                [formGroup]="condition.formGroup!"
                [required]="true"
                [options]="hourOptions"
                [optionIsSelf]="true"
              >
              </lhpe-select>

              <lhpe-select
                class="minute"
                controlName="startTimeOfDayMinutes"
                placeholder="mm"
                [formGroup]="condition.formGroup!"
                [required]="true"
                [options]="minuteOptions"
                [optionIsSelf]="true"
              >
              </lhpe-select>

              <lhpe-select
                class="pm"
                controlName="startTimeOfDayPM"
                [formGroup]="condition.formGroup!"
                [required]="true"
                [options]="pmOptions"
              >
              </lhpe-select>
            </div>
            <div
              class="row"
              style="
                width: 100%;
                display: flex;
                justify-content: center;
                margin-bottom: 10px;
                margin-top: 10px;
              "
            >
              <div class="text">and</div>
            </div>

            <div class="row">
              <lhpe-select
                class="hour"
                controlName="endTimeOfDayHour"
                placeholder="hh"
                [formGroup]="condition.formGroup!"
                [required]="true"
                [options]="hourOptions"
                [optionIsSelf]="true"
              >
              </lhpe-select>

              <lhpe-select
                class="minute"
                controlName="endTimeOfDayMinutes"
                placeholder="mm"
                [formGroup]="condition.formGroup!"
                [required]="true"
                [options]="minuteOptions"
                [optionIsSelf]="true"
              >
              </lhpe-select>

              <lhpe-select
                class="pm"
                controlName="endTimeOfDayPM"
                [formGroup]="condition.formGroup!"
                [required]="true"
                [options]="pmOptions"
              >
              </lhpe-select>
            </div>
          </div>
        </ng-container>

        <div class="container-row button-row">
          <button
            mat-icon-button
            class="delete-btn"
            *ngIf="
              !(
                condition.formGroup.controls.conditional.value?.type === 'timeAfterSent' &&
                data.is_follow_up &&
                idx === 0
              )
            "
            (click)="removeCondition(condition)"
          >
            <svg-icon
              src="assets/svg/trashcan.svg"
              [svgStyle]="{
                'width.px': '22.5',
                'height.px': '22.298'
              }"
              svgClass="lightGreyIcon"
            ></svg-icon>
          </button>
        </div>
      </div>
      <button
        *ngIf="conditions.length - 1 > idx"
        mat-icon-button
        (click)="changeOperator($event, idx)"
      >
        <svg-icon
          *ngIf="operators[idx] === 'and'"
          src="assets/svg/and-green-circle.svg"
        ></svg-icon>
        <svg-icon
          *ngIf="operators[idx] === 'or'"
          src="assets/svg/or-green-circle.svg"
        ></svg-icon>
      </button>
    </div>
    <button
      mat-icon-button
      *ngIf="conditionMode === 'structured'"
      (click)="addCondition($event)"
    >
      <svg-icon src="assets/svg/plus-green-circle.svg"></svg-icon>
    </button>
  </div>
</div>
